import React, { useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { hostsInstitutional } from "variables/global";
import { useTranslation } from "react-i18next";

const EnvironmentSelector = () => {
  const { t } = useTranslation();
  const [env, setEnv] = useState<string>("");

  useEffect(() => {
    const savedEnv = localStorage.getItem("app_env");
    const currentEnv =
      savedEnv &&
      hostsInstitutional[savedEnv as keyof typeof hostsInstitutional]
        ? savedEnv
        : process.env.REACT_APP_ENV || "development";
    setEnv(currentEnv);
  }, []);

  const handleValueChange = (value: string) => {
    localStorage.setItem("app_env", value);
    setEnv(value);
    window.location.reload();
  };

  return (
    <div className="w-full">
      <label className="text-sm  mb-1 block">{t("Select Environment")}</label>
      <Select value={env} onValueChange={handleValueChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder={t("Select environment")} />
        </SelectTrigger>
        <SelectContent>
          {Object.keys(hostsInstitutional).map((key) => (
            <SelectItem key={key} value={key}>
              {key.charAt(0).toUpperCase() + key.slice(1)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default EnvironmentSelector;
